import { useEffect, useState } from 'react'
import { SVGOverlay, TileLayer, useMap } from 'react-leaflet'
import { PLOT_SIDE } from './plot.lib'

const GridTileLayer = () => {
    
    const map = useMap()
    const [gridSize, setGridSize] = useState(null)
    
    const background = `<svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
            <defs>
                <pattern id="tinyGrid" width="${gridSize / 4}" height="${gridSize / 4}" patternUnits="userSpaceOnUse">
                    <path d="M ${gridSize / 4} 0 L 0 0 0 ${gridSize / 4}" fill="none" stroke="#888"
                        stroke-dasharray="${gridSize / 40}" stroke-width="0.3"/>
                </pattern>
                <pattern id="smallGrid" width="${gridSize / 2}" height="${gridSize / 2}" patternUnits="userSpaceOnUse">
                    <rect width="${gridSize / 2}" height="${gridSize / 2}" fill="url(#tinyGrid)"/>
                    <path d="M ${gridSize / 2} 0 L 0 0 0 ${gridSize / 2}" fill="none" stroke="#888" stroke-width="0.5"/>
                </pattern>
                <pattern id="grid" width="${gridSize}" height="${gridSize}" patternUnits="userSpaceOnUse">
                    <rect width="${gridSize}" height="${gridSize}" fill="url(#smallGrid)"/>
                    <path d="M ${gridSize} 0 L 0 0 0 ${gridSize}" fill="none" stroke="#000" stroke-width="1"/>
                </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#grid)" />
        </svg>`
    
    useEffect(() => {
        
        map.on('zoom', ev => {
            setGridSize(Math.pow(2, ev.target._zoom))
        })
        
        setGridSize(Math.pow(2, map.getZoom()))
        
        return () => {
            map.off('zoom')
        }
        
    }, [map])
    
    return (
        <>
            <TileLayer url={`data:image/svg+xml;utf8,${encodeURIComponent(background)}`} tileSize={1024} />
            <SVGOverlay bounds={[[0, 0], [PLOT_SIDE * -1, PLOT_SIDE]]}>
                <rect x="0" y="0" width="100%" height="100%" fill="none" stroke="#555" strokeWidth={4} />
                {Array(Math.pow(PLOT_SIDE, 2)).fill(0).map((_, i) => {
                    const row = Math.floor(i / PLOT_SIDE)
                    const col = row % 2 ? i % PLOT_SIDE : (PLOT_SIDE - 1) - (i % PLOT_SIDE)
                    const y = gridSize * row + 16
                    const x = col * gridSize + PLOT_SIDE
                    
                    return (<text
                        style={{ userSelect: 'none' }}
                        x={x} y={y} stroke="none" fill="#888" fontSize="12px" fontFamily="Arial">{i + 1}</text>)
                })}
            </SVGOverlay>
        </>
    )
}

export default GridTileLayer